import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { CommsService } from '../../services/comms/comms.service';
import { DataService } from '../../services/data/data.service';
import { ConfigService } from '../../services/config/config.service';
import { PurchaseOrderService } from '../../services/purchase-order/purchase-order.service';
import { DisplayService } from '../../services/display/display.service';
import { HelpService } from '../../services/help/help.service';
import { SmartContractService } from '../../services/smart-contract/smart-contract.service';
import { NoteService } from '../../services/note/note.service';
import { TimesheetService } from '../../services/timesheet/timesheet.service';
import { ActivatedRoute } from '@angular/router';
import { TabService } from '../../services/tab/tab.service';
import { IfStmt } from '@angular/compiler';
import _ from 'lodash';

@Component({
	selector: 'pcm-page-pos',
	templateUrl: './page-pos.component.html',
	styleUrls: ['./page-pos.component.scss']
})
export class PagePosComponent implements OnInit, OnDestroy {

	@ViewChild('modalForm') modalForm;
	@ViewChild('poMigrateModalForm') poMigrateModalForm;

	title = 'Purchase Orders';
	dataObj = this.configService.purchaseOrderDataObj;
	scDataObj = this.configService.poSCDataObj;

	actions = [];
	archivedActions = [];
	delegatedActions = [];
	nocontractorsActions = [];
	cancellationActions = [];
	expiringActions = [];
	anyActions = [];

	showExportModal = false;
	showConfirmationModal = false;
	partialSuccessTitle = 'Purchase Orders Archive/Restore Error(s)';
	confirmationMsg = 'Please be aware that by archiving/restoring the selected purchase orders, the contractor(s) associated with the purchase order will be archived/restored as well.';
	errorMsg = 'Some of the purchase orders failed archiving/restoring. See the table below for details.';
	successMsg = 'The following purchase orders were archived/restored successfully.';
	jrSteps = [];
	jrStepIDs = [];
	columnsConfigs = [];
	columnsConfigsUnarchived = [];

	userSettingsListener;

	currentEvent = '';
	initTab = '';

	constructor(
		private commsService: CommsService,
		public configService: ConfigService,
		private dataService: DataService,
		public purchaseOrderService: PurchaseOrderService,
		private displayService: DisplayService,
		public helpService: HelpService,
		private smartContractService: SmartContractService,
		public timesheetService: TimesheetService,
		private noteService: NoteService,
		private route: ActivatedRoute,
		private tabService: TabService
	) {
		this.helpService.POs.forEach(step => {
			this.jrSteps.push(step);
			this.jrStepIDs.push(step.id);
		});
	}

	ngOnInit() {
		this.columnsConfigs = this.configService.getTableFields(this.purchaseOrderService.dataObj, false);
		this.columnsConfigsUnarchived = _.cloneDeep(this.columnsConfigs);
		// Removes the MGR Email feild from the NON-DELEGATED TAB for the CCA
		if (this.configService.persona === this.configService.validateCCAProp) {
			this.columnsConfigsUnarchived = this.columnsConfigsUnarchived.filter(col => col.prop !== 'pmemail');
		}
		this.actions = this.configService.getActions(this.dataObj);
		if (this.actions.length === 0) {
			this.actions.push(this.configService.getExportAction());
		}

		this.archivedActions = this.configService.getActions('archivedpurchaseorder');
		if (this.archivedActions.length === 0) {
			this.archivedActions.push(this.configService.getExportAction());
		}

		this.delegatedActions = this.configService.getActions('delegatedpurchaseorder');

		this.nocontractorsActions = this.configService.getActions('nocontractorspurchaseorder');

		this.cancellationActions = this.configService.getActions('cancellationpurchaseorder');

		this.expiringActions = this.configService.getActions('expiringpurchaseorder');

		this.anyActions = this.configService.getActions('anypurchaseorder');

		this.route.params.subscribe(params => {
			this.initTab = params['initTab'];
			this.tabService.loadTab(this.purchaseOrderService.tabsData.listTabs, this.purchaseOrderService, this.initTab);
		});

		this.userSettingsListener = this.dataService.userSettingsListener().subscribe((event) => {
			console.log('USER SETTINGS LISTENER');
			this.tabService.loadTab(this.purchaseOrderService.tabsData.listTabs, this.purchaseOrderService, this.initTab);
		});

		this.dataService.pageData['timesheeterror-temp-standard'] = [];
	}

	ngOnDestroy() {
		this.userSettingsListener.unsubscribe();
	}

	// loadTab(tabService, initTab) {
	// 	const self = this;
	// 	let foundInitTab = false;
	// 	if(self.initTab !== '') {
	// 		this.purchaseOrderService.tabsData.listTabs.forEach(function (d, i) {
	// 			console.log('CHECK TAB FOR INIT', d, self.tabService.showTab(d.persona, d.notPersona));
	// 			if (!foundInitTab) {
	// 				if(self.tabService.showTab(d.persona, d.notPersona)){
	// 					if (d.listTab && d.prop === self.initTab) {
	// 						foundInitTab = true;
	// 						console.log('SELECT INIT TAB');
	// 						self.purchaseOrderService.tabClick({}, d.prop, self.purchaseOrderService.tabsData.listTabs, 'standard');
	// 					}
	// 				} else {
	// 					console.log('NO ACCESS TAB');
	// 					self.noteService.displayError('You do not have access to the requested list. Loading default tab.');
	// 					self.purchaseOrderService.selectDefaultTab(self.purchaseOrderService.tabsData.listTabs);
	// 				}
	// 			}
	// 		});
	// 	}

	// 	if(!foundInitTab) {
	// 		console.log('SELECT DEFAULT TAB');
	// 		this.purchaseOrderService.selectDefaultTab(this.purchaseOrderService.tabsData.listTabs);
	// 	}
	// }

	/**
	 * Given a list of strings, return true if the current tab is one of those in the list
	 */
	isOnTab(tabs: string[]) {
		for (let i = 0; i < tabs.length; i++) {
			if (this.purchaseOrderService.getActiveTab(this.purchaseOrderService.tabsData.listTabs).prop === tabs[i]) return true;
		}
		return false;
	}

	getActionsForTab() {
		const thisTab = this.purchaseOrderService.getActiveTab(this.purchaseOrderService.tabsData.listTabs).prop;
		if (thisTab === 'nocontractors') {
			return this.nocontractorsActions;
		} else if (thisTab === 'unarchive' || thisTab === 'undelegated') {
			return this.actions;
		} else if (thisTab === 'archive') {
			return this.archivedActions;
		} else if (thisTab === 'delegated') {
			return this.delegatedActions;
		} else if (thisTab === 'cancellation') {
			return this.cancellationActions;
		} else if (thisTab === 'renewals') {
			return this.expiringActions;
		} else if (thisTab === 'any') {
			return this.anyActions;
		}
	}

	allowAction = () => {
		return this.dataService.selectedTableRows[0] !== undefined;
	}

	takeAction(event) {
		console.log('TAKE ACTION', event, this.dataService.selectedTableRows);
		this.currentEvent = event.action.prop;
		if (this.currentEvent === 'poarchive') {
			this.partialSuccessTitle = 'Purchase Orders Move to Inactive Error(s)';
			this.confirmationMsg = 'Please be aware that by moving the selected purchase orders to inactive, the contractors associated with the purchase orders will be moved to the inactive tab as well.';
			this.errorMsg = 'Some of the purchase orders failed moving to inactive tab.  See the table below for details.';
			this.successMsg = 'The following purchase orders were moved to inactive tab successfully.';
			this.showConfirmationModal = true;
		} else if (this.currentEvent === 'porestore') {
			this.partialSuccessTitle = 'Purchase Orders Restore Error(s)';
			this.confirmationMsg = 'Please be aware that by restoring the selected purchase orders, the contractors associated with the purchase orders will be restored as well.';
			this.errorMsg = 'Some of the purchase orders failed restoring.  See the table below for details.';
			this.successMsg = 'The following purchase orders were restored successfully.';
			this.showConfirmationModal = true;
		} else if (this.currentEvent === 'exporttocsv') {
			this.showExportModal = true;
		} else if (this.currentEvent === 'pomigrate') {
			if (this.dataService.selectedTableRows
				&& this.dataService.selectedTableRows.length > 1) {
				this.noteService.displayError('Please select only one cancelled PO to migrate.');
			} else {
				this.poMigrateModalForm.showModal(event.action, this.scDataObj, this.dataService.selectedTableRows);
			}
		} else {
			this.modalForm.showModal(event.action, this.scDataObj, this.dataService.selectedTableRows);
		}
	}

	archivePOs() {
		const pos = [];
		this.dataService.selectedTableRows.forEach((row) => {
			const po = {
				ponumber: row.ponumber,
				supplierid: row.supplierid
			};
			pos.push(po);
		});

		console.log('archive POs', pos);
		this.smartContractService.submitSmartContract(pos, 'poarchive', this);
	}

	restorePOs() {
		const pos = [];
		this.dataService.selectedTableRows.forEach((row) => {
			const po = {
				ponumber: row.ponumber,
				supplierid: row.supplierid
			};
			pos.push(po);
		});

		console.log('archive POs', pos);
		this.smartContractService.submitSmartContract(pos, 'porestore', this);
	}

	migratePO(event) {
		console.log('Migrate PO', event);
		const data = event.data['contracts'][0];
		data['newponumber'] = event.data['newponumber'];
		// to reuse error handling in smartContractService
		this.smartContractService.submitSmartContract(data, event.prop, this);
		const self = this;
		const delay = setTimeout(function () {
			self.poMigrateModalForm.formCancel();
		}, 1000);
	}

	modalSubmit(event) {
		console.log('MODAL SUBMIT', event);
		this.smartContractService.submitSmartContract(event.data, event.prop, this);
		const self = this;
		const delay = setTimeout(function () {
			self.modalForm.formCancel();
		}, 1000);
	}

	successCall() {
		console.log('ACTION SUCCESS', this.dataService.selectedTableRows);
		const self = this;
		const delay = setTimeout(function () {
			if (self.currentEvent === 'pomigrate') {
				self.poMigrateModalForm.formCancel();
			} else {
				self.dataService.clearSelectedTableRows();
				self.purchaseOrderService.loadPOsForTab(self.purchaseOrderService.getActiveTab(self.purchaseOrderService.tabsData.listTabs));
			}
		}, 1000);
	}

	errorCall(err) {
		if (this.currentEvent === 'pomigrate') {
			this.timesheetService.handlePartialSuccess({ error: err });
		} else if (this.currentEvent === 'poarchive' || this.currentEvent === 'porestore') {
			this.purchaseOrderService.handlePartialSuccess(err);
		} else {
			this.noteService.displayError('Failed to process the selected purchase orders');
		}
	}

	partialCall(res) {
		console.log('BULK PARTIAL SUCCESS');
		if (this.currentEvent === 'pomigrate') {
			this.timesheetService.handlePartialSuccess({ error: res });
		} else if (this.currentEvent === 'poarchive' || this.currentEvent === 'porestore') {
			this.purchaseOrderService.handlePartialSuccess(res);
		} else {
			this.noteService.displayError('Failed to process some or all the selected purchase orders');
		}
	}

	closeExportModal() {
		this.showExportModal = false;
	}

	isPrimaryTab() {
		const isPrimary =
			this.purchaseOrderService.getActiveTab(this.purchaseOrderService.tabsData.listTabs)['prop'] === 'unarchive'
			||
			this.purchaseOrderService.getActiveTab(this.purchaseOrderService.tabsData.listTabs)['prop'] === 'nocontractors';
		return isPrimary;
	}

	exportToCSV(event) {
		this.commsService.exportToCSV(event.data, this.configService.getTableFields(this.dataObj, false), this.dataService.selectedTableRows);
		const self = this;
		const delay = setTimeout(function () {
			self.closeExportModal();
		}, 1000);
	}

	cancelConfirmationModal() {
		this.showConfirmationModal = false;
	}

	confirmationFormSubmit(event) {
		console.log('CONFIRMATION FORM SUBMIT');
		if (this.currentEvent === 'poarchive') {
			this.archivePOs();
		} else if (this.currentEvent === 'porestore') {
			this.restorePOs();
		}
		this.showConfirmationModal = false;
	}
}
